<template>
    <div id="mobile">
        <section class="sec01">
            <a href="http://e.hengdianworld.com/yd_mp_activity.aspx?id=571">
                <img src="../images/mobile/b6.png" alt="" class="b6">
            </a>
        </section>
        <section class="sec02">
            <router-link to="/yxmhPC">
                <div class="btn3">
                    <img src="../images/mobile/b3.png" alt="">
                </div>
            </router-link>
            <router-link to="/jnmhPC">
                <div class="btn3 btn4">
                    <img src="../images/mobile/b3.png" alt="">
                </div>
            </router-link>
        </section>
        
        <section class="sec05">
            <div>
                <a href="http://e.hengdianworld.com/yd_tc_activity.aspx?id=139">
                <img src="../images/mobile/p5.png" alt="" class="p5">
                </a>
                <a href="http://e.hengdianworld.com/yd_tc_activity.aspx?id=155">
                    <img src="../images/mobile/p4.png" alt="" class="p4">
                </a>
                <a href="http://e.hengdianworld.com/yd_tc.aspx">
                    <img src="../images/mobile/b5.png" alt="" class="b5">
                </a>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: "mobileView",
    }
</script>

<style scoped lang="scss">
    $baseFontSize:7.9;
    @function px2vw($px){
        @return $px / $baseFontSize * 1vw;
    }
    section img{width: 100%;}
    a {
        outline: none;
    }
    * {

        -webkit-tap-highlight-color: transparent;
        -webkit-appearance: none;
    }
        section {position: relative;overflow: hidden;box-sizing: border-box;}
    .sec01 {
        background: url("../images/mobile/images/images/bg_01.jpg");
        background-size: cover;
        height: px2vw(545);
        .b6 {
            left:50%;
            position: absolute;
            transform: translate(-50%,0);
            top: 44vw;
            width: px2vw(179);
        }
    }
    .sec02 {
        background: url("../images/mobile/images/images/bg_02.jpg");
        background-size: cover;
        height: px2vw(866);
        .btn3 {
            width: px2vw(128);
            position: absolute;
            left: px2vw(80);
            top: 34vw;
        }
        .btn4 {
            top: 54vw;
        }
    }
    .sec03 {
        background: url("../images/mobile/images/images/bg_03.jpg");
        background-size: cover;
        height: px2vw(542);
        .p7 {
            width: px2vw(667);
        }

        >div {
            position: absolute;
            left: 7.3vw;
            top: 18vw;
        }

    }
    .sec04 {

        background: url("../images/mobile/images/images/bg_04.jpg");
        background-size: cover;
        height: 66.7vw;
        >div {
            position: absolute;
            left: 7.3vw;
            top: 20vw;
        }
        .p7 {
            margin-top: -2vw;
            margin-left:-.5vw;
            width: px2vw(664);
        }
        .p1 {
            margin-left: .5vw;
            width: px2vw(331);
        }
        .p2 {
            width: px2vw(320);

        }
        .p3 {
            width: px2vw(674);
            margin-left: -.5vw;
        }
        .b2 {
            width: px2vw(314);
            position: absolute;
            top: 150.5vw;
            left: 46%;
            transform: translate(-50%, 0);
        }

    }
    .sec05 {
        background: url("../images/mobile/images/images/bg_05.jpg");
        background-size: cover;
        height: px2vw(1320);
        .p5 {
            margin-left: .5vw;
            width: px2vw(649);
        }
        .p4 {
            width: px2vw(654);
        }
        >div {
            left: 7.3vw;
            top: 27vw;
            position: absolute;
        }
        .b5 {
            width: px2vw(314);
            position: absolute;
            top: 118vw;
            left: 46%;
            transform: translate(-50%, 0);
        }

    }


</style>